export const prompts: any = {
  QQMALL: {
    'Diskaun': "Adakah anda menawarkan sebarang diskaun atau promosi?",
    'Pengembalian barang': "Apa yang harus saya lakukan jika saya menerima barang yang rusak atau cacat?",
    'Maklumat logistik': "Berapa lama masa yang diperlukan untuk penghantaran pesanan saya?",
    'Cara pembayaran': "Metode pembayaran apa yang diterima oleh QQ Mall?"
  },
  DR: {
    'Location': 'Where is your clinic located?',
    'Operating Hours': "What are your clinic's operating hours?",
    'Appointment': "How can I make an appointment?",
    'Teeth Whitening': "Do you offer teeth whitening services?"
  },
  chatbot: {}
}

export const ROBOT_USERS = [
  {
    userID: '@RBT#AK3PWmVXZu3ByVOE',
    key: 'QQMALL',
  },
  {
    userID: '@RBT#KZJb8oATrgUnETai',
    key: 'DR'
  },
  {
    userID: '@RBT#1709723602BMhWkfTr',
    key: 'chatbot'
  },
]

export const ROBOT_WELCOME_PAYLOAD = {
  data: JSON.stringify({
    chatbotPlugin: 1,
    src: 8
  }),
  description: '',
  extension: ''
}

export const ROBOT_ACTIVE_PAYLOAD = {
  data: JSON.stringify({
    chatbotPlugin: 1,
    src: 7
  }),
  description: "",
  extension: "",
}